
// @ts-nocheck

import Vue, {PropOptions} from 'vue'
import Cropper from 'cropperjs';

import 'cropperjs/dist/cropper.min.css';
import _ from 'lodash';
import { windowResizeMixinForChild } from '~/lib/util/window_resize_mixin_for_root';


function getNewCropper(el: any, options: Cropper.Options<HTMLImageElement> = {}) {
  const cropper = new Cropper(el, options);

  // @ts-ignore
  window.el = el;
  // @ts-ignore
  window.Cropper = Cropper;
  // @ts-ignore
  window.cropper = cropper;

  type DataType = 'container' | 'canvas' | 'image' | 'cropbox' | 'data';

  function toActualType(type: DataType) {
    if(type === 'cropbox') {
      return 'cropBox';
    } else if(type === 'data') {
      return '';
    }
    return type;
  }

  function toMethodName(prefix: 'get' | 'set', type: DataType) {
    const type_ = toActualType(type);
    return `${prefix}${type_ ? type_[0].toUpperCase() + type_.slice(1) : ''}Data`;
  }

  function set_cropper_value(type: DataType, key: string, value: any) {
    const type_ = toActualType(type);

    const getMethodName = toMethodName('get', type);
    const setMethodName = toMethodName('set', type);

    console.log(`>> ${setMethodName} :: ${key} -> ${value})`);

    // @ts-ignore
    cropper[setMethodName]({
      // @ts-ignore
      ...cropper[getMethodName](),
      [key]: value
    })
  }

  function get_cropper_value(type: DataType, key: string) {
    const type_ = toActualType(type);

    const getMethodName = toMethodName('get', type);

    // console.log(`>> ${getMethodName} :: ${key}`);

    if(key === 'left' && type === 'data') {
      key = 'x';
    }
    if(key === 'top' && type === 'data') {
      key = 'y';
    }

    // @ts-ignore
    return cropper[getMethodName]()[key];
  }

  function get_all_cropper_values(key: string) {
    return {
      container: get_cropper_value('container', key),
      canvas: get_cropper_value('canvas', key),
      image: get_cropper_value('image', key),
      cropbox: get_cropper_value('cropbox', key),
      data: get_cropper_value('data', key),
    }
  }

  function set_cropper_data_kv_in_rel(key: string, value: number) {
    const imageData = cropper.getImageData();
    const ratio = imageData.width / imageData.naturalWidth;

    const value_in_rel = value / ratio;

    set_cropper_value('data', key, value_in_rel);
  }

  function set_cropper_data_in_rel_units(obj: {[key: string]: number}) {
    const imageData = cropper.getImageData();
    const ratio = imageData.width / imageData.naturalWidth;

    const rescaled_obj = _.mapValues(obj, value => value / ratio);

    const data = cropper.getData();
    cropper.setData({
      ...data,
      ...rescaled_obj
    });
  }

  function check_initial_state() {
    set_cropper_value('data', 'rotate', 0);  // so we don't get undefined values in e.g. imageData.rotate

    const cropBoxData = cropper.getCropBoxData();
    const imageData = cropper.getImageData();
    const canvasData = cropper.getCanvasData();

    // We assume no rotations.
    // Or rotations by n*90 degrees only.

    function check1(){ return [imageData.rotate == 0                      , imageData.rotate]       ; }
    function check2(){ return [imageData.width == canvasData.width        , {imageData, canvasData}]; }
    function check3(){ return [imageData.height == canvasData.height      , {imageData, canvasData}]; }
    function check4(){ return [imageData.scaleX == 1                      , imageData.scaleX]       ; }
    function check5(){ return [imageData.scaleY == 1                      , imageData.scaleY]       ; }
    function check6(){ return [imageData.left == 0 || imageData.top == 0  , {imageData}]            ; }
    function check7(){ return [canvasData.left == 0 || canvasData.top == 0, {canvasData}]           ; }
    function check8(){ return [imageData.width / imageData.height == imageData.aspectRatio, {imageData}]           ; }

    const checks = [check1, check2, check3, check4, check5, check6, check7, check8];

    let any_failed = false;
    for(const check of checks) {
      const [result, context] = check();
      if(! result) {
        console.warn(`Check ${check.name} failed (${check.toString()}), context=`, context);
        any_failed = true;
      } else {
        console.log(`Check ${check.name} passed.`);
      }
    }

    if(any_failed) {
      console.warn('Checks failed, not configuring cropper.');
    }

    return ! any_failed;
  }

  function configure_cropper() {
    cropper.clear();
    cropper.reset();
    cropper.crop();

    if(! check_initial_state()) {
      return;
    }

    let cropBoxData = cropper.getCropBoxData();
    let imageData = cropper.getImageData();
    let canvasData = cropper.getCanvasData();
    let containerData = cropper.getContainerData();

    const ratio = imageData.width / imageData.naturalWidth;
    const imgAspectRatio = imageData.aspectRatio;
    const containerAspectRatio = containerData.width / containerData.height;

    // Margin left-right or top-bottom of crop box. Visible in gray area (in container area).
    const margin = 30;
    const margin_2x = margin * 2;

    const newCropBoxWH = (containerAspectRatio > 1 ? containerData.height : containerData.width) - margin_2x;
    const currCropBoxWH = cropBoxData.width;

    const resizeFactor = newCropBoxWH / currCropBoxWH;

    if(resizeFactor <= 1) {
      return 1;
    }

    // 0. clear crop box
    cropper.clear();

    // 1. resize canvas
    cropper.setCanvasData({
      ...canvasData,
      width: canvasData.width * resizeFactor,
      height: canvasData.height * resizeFactor,
    });

    cropBoxData   = cropper.getCropBoxData();
    imageData     = cropper.getImageData();
    canvasData    = cropper.getCanvasData();
    containerData = cropper.getContainerData();

    // 2. move canvas to center
    const {width: containerWidth, height: containerHeight} = containerData;

    const center = [containerWidth / 2, containerHeight / 2];

    const left = center[0] - canvasData.width / 2;
    const top = center[1] - canvasData.height / 2;

    cropper.setCanvasData({
      ...canvasData,
      left: left,
      top: top,
    });

    // 3. resize crop box and move it to center
    cropper.crop();

    cropper.setCropBoxData({
      width: newCropBoxWH,
      height: newCropBoxWH,
      left: center[0] - newCropBoxWH / 2,
      top: center[1] - newCropBoxWH / 2,
    });

    return resizeFactor;
  }

  _.extend(window, {
    set_cropper_value,
    get_cropper_value,
    get_all_cropper_values,
    set_cropper_data_in_rel_units,
    configure_cropper
  })

  return _.extend(cropper, {
    configure_cropper
  });
}

export default Vue.extend({
  mixins: [windowResizeMixinForChild],
  props: {
    src: {
      type: String,
      required: false
    } as PropOptions<string | undefined>,
    cropperEnabled: {
      type: Boolean,
      default: true
    },
    options: {
      type: Object,
      default: {}
    } as PropOptions<Cropper.Options<HTMLImageElement>>,

    // interactive props
    zoom: {
      type: Number,
      default: 1
    } as PropOptions<number>,

    minZoom: {
      type: Number,
      default: 0
    } as PropOptions<number>,
    maxZoom: {
      type: Number,
      default: Infinity
    } as PropOptions<number>,

  },
  data() {
    return {
      cropper: undefined as Cropper | undefined,
      initialScale: 0.1,
      emitUpdatedZoom: false,
    }
  },
  methods: {
    init(cropperEnabled: boolean) {
      if(cropperEnabled && this.src) {
        this.addCropper();
      } else {
        this.removeCropper();
      }
    },
    rotate(degrees: number) {
      if(this.cropper) {
        this.cropper.rotate(degrees);
      }
    },
    scale(scale: number) {
      if(this.cropper) {
        this.cropper.scale(scale, scale);
      }
    },
    async my_reconfigure() {
      const rotate = get_cropper_value('image', 'rotate');

      this.removeCropper();
      // await this.$nextTick();
      await this.addCropper();
      // await this.$nextTick();
      this.cropper.rotateTo(rotate);
    },
    addCropper() {
      return new Promise((resolve, reject) => {
        if(this.cropper) {
          this.cropper.destroy();
        }

        const el: HTMLImageElement = this.$refs!.img as HTMLImageElement;

        let rest = {};

        const self = this;

        async function ready(event: any) {
          // @ts-ignore
          const cropper: Cropper = this.cropper;

          // @ts-ignore
          cropper.configure_cropper();

          const canvasData = cropper.getCanvasData();
          self.$emit('update:imageData', canvasData);
          self.initialScale = canvasData.height / canvasData.naturalHeight;

          function onActivity() {
            self.$emit('activated');
            el.removeEventListener('cropstart', onActivity);
          }
          el.addEventListener('cropstart', onActivity);

          resolve();

          // so we run below code after `await this.addCropper()` in my_reconfigure()
          await self.$nextTick();

          if(self.options.ready) {
            self.options.ready(event);
          }

          this.emitUpdatedZoom = true;
        }

        this.cropper = getNewCropper(el, {
          ..._.omit(this.options, 'ready'),
          ready: ready
        });
      });
    },
    removeCropper() {
      this.cropper?.destroy();
      this.cropper = undefined;
    },
//     ready(event: any, cropper: Cropper) {
//       const ratio = this.zoomToRatio(this.zoom);
//       // cropper.zoomTo(ratio);
//
//       this.emitUpdatedZoom = true;
//     },
    getCroppedBlob() {
      if(! this.cropper) {
        return Promise.reject('Cropper not initialized');
      }
      return new Promise<Blob>((resolve, reject) => {
        this.cropper!.getCroppedCanvas().toBlob((blob: Blob | null) => {
          if(blob) {
            resolve(blob);
          } else {
            reject('Failed to get cropped blob');
          }
        });
      });
    },
    onCropperZoom(event: any) {
      const zoom = this.ratioToZoom(event.detail.ratio);

      if(zoom < this.minZoom || zoom > this.maxZoom) {
        console.log('Preventing zoom', zoom, this.minZoom, this.maxZoom);
        return event.preventDefault();
      }

      if(this.emitUpdatedZoom) {
        this.$emit('update:zoom', zoom);
      }
    },
    ratioToZoom(ratio: number) {
      return ratio / this.initialScale;
    },
    zoomToRatio(zoom: number) {
      return zoom * this.initialScale;
    }
  },
  watch: {
    cropperEnabled(val) {
      this.init(val);
    },
    async zoom(zoom: number) {
      if(this.cropper) {
        // Block emitting zoom event to prevent possible infinite loop.
        this.emitUpdatedZoom = false;

        // const ratio = this.initialScale * zoom;
        const ratio = this.zoomToRatio(zoom);

        console.log(`zoom: ${zoom}, ratio: ${ratio}`);
        this.cropper.zoomTo(ratio);

        await this.$nextTick();
        this.emitUpdatedZoom = true;
      }
    }
  },
  mounted() {
    this.init(this.cropperEnabled);

    // @ts-ignore
    window.$cropper = this;

    this.$onWindowResize(() => {
      if(this.cropper) {
        this.my_reconfigure();
      }
    });
  },
  beforeDestroy() {
    this.removeCropper();
  }
})
